import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { PurchaseRequest } from './purchase-request.model';

export class WorkOrder extends BitfStrapiModel {
  documentId: string;
  idSiebel: number;
  mosCrDm: number;
  totalBo: number;
  entryGoodsStatus: string;
  psEngagment: string;
  purchaseRequests: PurchaseRequest[];

  constructor(data: Partial<WorkOrder> = {}) {
    super({ data });

    if (data.purchaseRequests) {
      this.purchaseRequests = data.purchaseRequests.map(
        purchaseRequest => new PurchaseRequest(purchaseRequest)
      );
    }
  }

  get serialised() {
    return {
      entryGoodsStatus: this.entryGoodsStatus,
      psEngagment: this.psEngagment,
    };
  }
}
